module.exports = __webpack_public_path__ + "4cc39a77a33b2746874fead02e2caee7.png";